import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./modules";

let store;

//如果不是生产环境，并且检测到chrome浏览器有REDUX_DEVTOOLS插件工具，使用composeEnhancers去做功能增强
// if(
//     process.env.NODE_ENV !== "production" &&
//     window._REDUX_DEVTOOLS_EXTENSION_
// ) {
//     const composeEnhancers =
//     window._REDUX_DEVTOOLS_EXTENSION_COMPOSE_;
//     store = createStore(rootReducer,composeEnhancers(applyMiddleware(thunk)));
// } else{
//     store = createStore(rootReducer,applyMiddleware(thunk));
// }
store = createStore(rootReducer,applyMiddleware(thunk));
export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js